import { apiResponseErrorHandler } from 'helpers/common.helper';
import axios from 'axios';

export default {


	saveInboundingData(data) {
		return this.handelAlert((res, rej, loadObj) => {
			axios
				.post(`${base}/api/task-inbounding/save-details`, data, {
					headers: {
						Authorization: `Bearer ${(JSON.parse(localStorage.getItem('user'))?.token  || JSON.parse(sessionStorage.getItem('user')).token) || token}`
					}
				})
				.then((response) => {
					res(response.data);
				})
				.catch((rej) => {
					apiResponseErrorHandler(rej);
					res(rej.response.data);
				});
		}, false);
	},


	updateStockRepair(data) {
		return this.handelAlert((res, rej, loadObj) => {
			axios
				.post(`${base}/api/stocks/repair`, data, {
					headers: {
						Authorization: `Bearer ${(JSON.parse(localStorage.getItem('user'))?.token  || JSON.parse(sessionStorage.getItem('user')).token) || token}`
					}
				})
				.then((response) => {
					res(response.data);
				})
				.catch((rej) => {
					apiResponseErrorHandler(rej);
					res(rej.response.data);
				});
		}, false);
	},
	
};
